import React, { useState, useEffect } from 'react'
import { Box, IconButton, Typography, Divider, Button } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import DeleteIcon from '@mui/icons-material/Delete';
import EmpModalContainer from '../../../containers/common/form/modal/EmpModalContainer';
import _ from 'lodash';

const TechUsersForm = ({ formik, ccUsers, addCcUsers, removeCcUser }) => {
    const [open, setOpen] = useState(false);
    const [type, setType] = useState(null);
    const [roleTyp, setRoleTyp] = useState("");
    const [worker, setWorker] = useState(null);
    const [title, setTitle] = useState(null);
    const [multi, setMulti] = useState(false);

    useEffect(() => {
        if (formik.values?.workEmpInf) {
            setWorker(formik.values?.workEmpInf);
        }
    }, [formik.values?.workEmpInf])


    const openEmpModal = (type) => {
        setOpen(true);
        setType(type);

        if (type === 'cc') {
            setTitle("참조자 선택 - 사원 리스트");
            setMulti(true);
            setRoleTyp("");
        } else {
            setTitle("작업자 선택 - 사원 리스트");
            setMulti(false);
            setRoleTyp("TECH");
        }
    }

    const handleClose = () => {
        setOpen(false);
        setType(null);
        setRoleTyp("");
        setTitle(null);
        setMulti(false);
    }

    const selectedEmployee = (emp) => {

        if (type === 'workEmp') {
            setWorker(emp);
            formik.setFieldValue('workEmp', emp.usrUuid);
        } else if (type === 'cc') {

            addCcUsers(emp);//array
        }
    }

    const removeItem = (emp) => {
        removeCcUser(emp);
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="subtitle2" component="div">작업 담당자</Typography>
                <Button variant="outlined" color="secondary" onClick={() => openEmpModal('workEmp')}>작업자 선택</Button>
            </Box>
            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                {worker === null ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography variant="subtitle2" component="div">선택된 작업자가 없습니다</Typography>
                    </Box>
                ) : (
                    <TableContainer component={Box}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>부서명</TableCell>
                                    <TableCell>이름</TableCell>
                                    <TableCell>직급</TableCell>
                                    <TableCell>연락처</TableCell>
                                    <TableCell>이메일</TableCell>
                                    <TableCell>성별</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow >
                                    <TableCell>{worker?.dptNm}</TableCell>
                                    <TableCell>{worker?.usrNm}</TableCell>
                                    <TableCell>{worker?.gradeNm}</TableCell>
                                    <TableCell>{worker?.emlAddr}</TableCell>
                                    <TableCell>{worker?.telNo}</TableCell>
                                    <TableCell>{worker?.gender === 'M' ? '남성' : '여성'}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

            </Box>


            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="subtitle2" component="div">작업 담당자</Typography>
                <Box>
                    <Button variant="outlined" color="secondary" onClick={() => openEmpModal('cc')}>참조자 선택</Button>
                </Box>
            </Box>
            <Divider sx={{ my: 1 }} />
            {ccUsers.length === 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography variant="subtitle2" component="div">선택된 참조자가 없습니다.</Typography>
                </Box>
            ) : (
                <TableContainer component={Box}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>No</TableCell>
                                <TableCell>부서명</TableCell>
                                <TableCell>이름</TableCell>
                                <TableCell>직급</TableCell>
                                <TableCell>연락처</TableCell>
                                <TableCell>이메일</TableCell>
                                <TableCell>성별</TableCell>
                                <TableCell>삭제</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {ccUsers.map((usr, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{usr?.dptNm}</TableCell>
                                        <TableCell>{usr?.usrNm}</TableCell>
                                        <TableCell>{usr?.gradeNm}</TableCell>
                                        <TableCell>{usr?.emlAddr}</TableCell>
                                        <TableCell>{usr?.telNo}</TableCell>
                                        <TableCell>{usr?.gender === 'M' ? '남성' : '여성'}</TableCell>
                                        <TableCell><IconButton size="small" onClick={() => removeItem(usr)}><DeleteIcon /></IconButton></TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            <EmpModalContainer
                title={title}
                multi={multi}
                open={open}
                roleTyp={roleTyp}
                handleClose={handleClose}
                selectedEmployee={selectedEmployee}
            />
        </Box>
    )
}

export default TechUsersForm